export default "__VITE_ASSET__baa30f53__"